module.exports = __webpack_public_path__ + "static/media/header2-bg.fef5d456.webp";